import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import axios, { AxiosError } from "axios";
import { spinner } from "../utils/customizeAxios";
axios.defaults.withCredentials = true;


export default function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loginErr, setLoginErr] = useState('');
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_URL;

    const { setCurrentUser } = useAuth();

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsLoading(true)
        await axios.post(apiUrl + '/login', {
                email: email,
                password: password,
            },{
                headers: {
                    "Content-Type": "application/json",
                    'X-Requested-With': 'XMLHttpRequest',
                },
                withCredentials: true,
            }).then(response => {
                if (response.status === 200){
                    console.log(response.data);
                    setCurrentUser(response.data)
                    navigate('/class');
                }else {
                    setLoginErr("Wrong name or password");
                    console.log('Err1' + response.data.error);
                }
            })
            .catch(error => {

                switch (error) {
                    case AxiosError.ERR_NETWORK:
                        setLoginErr("You are not connected to a network. Please switch on data connection");
                        break
                    default:
                        if(error.response) {
                            setLoginErr(error.response.data.message ?? error.response.data.error ?? "Unknown error occured, please verify your input and try again")
                        } else {
                            setLoginErr("Unknown error occured")
                        }
                        break
                }
                console.error('Err2' + error.response.data.error)
            });
            setIsLoading(false)
    };
    

    return (
        <div className="h-screen items-center flex justify-center bgimg text-white">
            <div className="flex justify-center my-auto">
                <section>
                    <div className="text-center text-3xl mb-4 font-bold text-slate-300 border-t-2 rounded-lg font-serif">SEETA C.o.U PRIMARY SCHOOL</div>
                <form className="px-6 py-8 rounded-lg bg-black/50 
                                backdrop-blur-md w-80 mx-auto" 
                        onSubmit={e => handleSubmit(e) }>
                <div className="font-bold flex justify-center">Login</div>
                    <div className="mt-4">
                        <div className="">
                            <label htmlFor="email">Email: </label>
                        </div>
                        <div className="w-full">
                            <input type="email" 
                                    name="email"
                                    value={email}
                                    onChange={e => setEmail(e.target.value)} 
                                    className="rounded-md p-1 
                                            bg-slate-50/10 w-full"
                            />
                        </div>
                    </div>

                    <div className="mt-4">
                        <div className="">
                            <label htmlFor="password">Passsword: </label>
                        </div>
                        <div className="">
                            <input type="password" 
                                    name="password"  
                                    value={password}
                                    onChange={e => setPassword(e.target.value)} 
                                    className="rounded-md p-1 
                                            bg-slate-50/20 w-full"
                            />
                        </div>
                    </div>
                    <div className="text-red-700"> {loginErr} </div>
                    <div className="flex justify-center">
                        {isLoading ?
                        <div className="cursor-wait bg-puple-500 text-white font-light shadow-md ring-1 ring-gray-400 px-6 rounded-lg my-4">
                            {spinner}
                        </div>
                        :
                        <button type="submit" className="bg-puple-500 text-white font-light shadow-md ring-1 ring-gray-400 px-6 rounded-lg my-4">
                            Login
                        </button>
                        }
                        
                    </div>
                </form>
                </section>
            </div>
        </div>
    );
}